import {AbstractModel} from '../abstract-model';

export class Rate extends AbstractModel {
  current: number = 0;
  limit: number | null = null;

  isLimited(): boolean {
    if (this.limit === null) {
      return false;
    }

    return this.current >= this.limit;
  }
}
